import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsUpcScan } from 'react-icons/bs';

import './SupportingDocumentButton.scss';
import { useWorkReportModals } from '../../../../context/WorkReportModalsContext';

const SupportingDocumentButton = (props) => {
  const {
    data,
    supportingDocument,
    monthly,
    editable,
    onAction,
    setNewFetch,
    selectedDate,
    maxDate,
    minDate
  } = props;
  const { activeSupportingDocumentModal } = useWorkReportModals();

  const buttonColors = useMemo(() => {
    // If not editable
    if (!editable) {
      // If it has a loaded document, the background changes
      return {
        color: supportingDocument ? '#ffffff' : '#bbbbbb',
        bgColor: supportingDocument ? '#159AD8' : '#ffffff00'
      };
    }

    // If editable
    // If it has a loaded document, the background changes
    return {
      color: supportingDocument ? '#ffffff' : '#575757',
      bgColor: supportingDocument ? '#159AD8' : '#ffffff00'
    };
  }, [supportingDocument, editable]);

  const onPreesButton = () => {
    if (!editable && !supportingDocument) {
      return;
    }
    if (onAction) {
      onAction(data);
    }
    activeSupportingDocumentModal({
      data,
      monthly,
      selectedDate,
      maxDate,
      minDate,
      updateLineData: () => setNewFetch((val) => !val)
    });
  };

  return (
    <OverlayTrigger
      delay={{
        show: 250,
        hide: 400
      }}
      overlay={<Tooltip id="supporting-document-tooltip">Ident. de Documento de Respaldo</Tooltip>}
      placement="top"
    >
      <button className="supporting_document" onClick={onPreesButton} type="button">
        <BsUpcScan
          color={buttonColors.color}
          strokeWidth={0.5}
          style={{
            backgroundColor: buttonColors.bgColor
          }}
        />
      </button>
    </OverlayTrigger>
  );
};

SupportingDocumentButton.propTypes = {
  data: PropTypes.shape({}),
  setNewFetch: PropTypes.func.isRequired,
  supportingDocument: PropTypes.string,
  editable: PropTypes.bool,
  onAction: PropTypes.func,
  monthly: PropTypes.bool,
  selectedDate: PropTypes.string,
  maxDate: PropTypes.string,
  minDate: PropTypes.string
};

SupportingDocumentButton.defaultProps = {
  data: {},
  supportingDocument: null,
  editable: false,
  onAction: () => {},
  monthly: false,
  selectedDate: null,
  maxDate: null,
  minDate: null
};

export default SupportingDocumentButton;
